import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  //MFBottlerSelection REDUX part
  MFbottlerData: [],
  MFtransformedTreeData: [],
  MFselectedTreeIds: [],
  MFfinalTreeData: [],
  MFfilterApplied: false,
};

const MFEntityTree = createSlice({
  name: "MFentity",
  initialState,
  reducers: {
    setMFBottlerData: (state, action) => {
      state.MFbottlerData = action.payload;
    },
    setMFTransformedTreeData: (state, action) => {
      state.MFtransformedTreeData = action.payload;
    },
    setMFSelectedTreeIds: (state, action) => {
      state.MFselectedTreeIds = action.payload;
    },
    setMFFinalTreeData: (state, action) => {
      state.MFfinalTreeData = action.payload;
    },
    setMFFilterApplied: (state, action) => {
      state.MFfilterApplied = action.payload;
    },
  },
});

export const {
  setMFBottlerData,
  setMFTransformedTreeData,
  setMFSelectedTreeIds,
  setMFFinalTreeData,
  setMFFilterApplied,
} = MFEntityTree.actions;
export default MFEntityTree.reducer;
